import { Controller } from "@hotwired/stimulus"

// Count-up rest stopwatch. Mounts (fresh) each time a set is completed and starts from zero;
// tapping it dismisses the bar.
export default class extends Controller {
  static targets = ["time"]

  connect() {
    this.started = Date.now()
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    let s = Math.floor((Date.now() - this.started) / 1000)
    const m = Math.floor(s / 60)
    s -= m * 60
    const pad = (n) => String(n).padStart(2, "0")
    this.timeTarget.textContent = `${pad(m)}:${pad(s)}`
  }

  dismiss(event) {
    event.preventDefault()
    clearInterval(this.timer)
    this.element.remove()
  }
}
